import { executeRequest, Request, Response } from '@jfs/network'
import { isEmpty } from '@jfs/utils'
import { RootStore } from '../data/store'
import { AESEncrypt, generateRandomString, RSAEncrypt } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { appSessionRefreshConfig, getBaseUrl } from './config'
import { pickLocalStorageValue } from './ExtendUserSession'

const responseParser = (response: any) => ({
  identifierToken: response?.session?.appIdentifierToken,
  refreshToken: response?.session?.refreshToken?.tokenValue,
  accessToken: response?.session?.accessToken?.tokenValue,
  accessTokenExpiresIn: response?.session?.accessToken?.expiresIn,
  refreshTokenExpiresIn: response?.session?.refreshToken?.expiresIn,
})

export const extendAppSession = (storeAccessToken: string, storeRefreshToken: string) => {
  const accessToken = pickLocalStorageValue('appAccessToken', storeAccessToken)
  const refreshToken = pickLocalStorageValue('appRefreshToken', storeRefreshToken)
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, accessToken)
  let refToken = AESEncrypt(randomEncryptionKey, refreshToken)

  const request: Request<{}> = {
    apiPath: `${getBaseUrl()}${APIEndPoints.appSessionExtend}`,
    method: 'POST',
    headers: appSessionRefreshConfig().headers,
    body: {
      application: {
        clientId: window?._env_?.REACT_APP_CLIENT_ID,
      },
      authenticateList: [
        {
          mode: 14,
          accessToken: token,
          refreshToken: refToken,
        },
      ],
      scope: 'SESSION',
      purpose: 1,
      secure: {
        encryptionKey: encryptedKey ?? '',
      },
    },
  }
  return request
}

export const AppHeaderTransformer = (response: Response, originalRequest?: Request<any>) => {
  if (response) {
    const { data } = response
    if (
      !isEmpty(data?.session?.accessToken?.tokenValue) &&
      !isEmpty(data?.session?.refreshToken?.tokenValue) &&
      !isEmpty(data?.session?.appIdentifierToken)
    ) {
      const appSessionData = responseParser(data)

      RootStore.session.updateAppSessionData(
        appSessionData.accessToken,
        appSessionData.refreshToken,
        appSessionData.accessTokenExpiresIn,
        appSessionData.refreshTokenExpiresIn,
        appSessionData.identifierToken,
      )

      if (
        appSessionData &&
        originalRequest &&
        appSessionData.accessToken &&
        appSessionData.identifierToken &&
        originalRequest.headers
      ) {
        originalRequest.headers = {
          ...originalRequest.headers,
          'x-app-access-token': appSessionData.accessToken,
          'x-trace-id': generateRandomString(16),
          'x-appid-token': appSessionData.identifierToken,
        }
      }
    } else {
      // RootStore.session.updateAppSessionData('', '', -1, -1, '')
      RootStore.session.logout(true)
    }
  }
}

export const extendAppSessionAPI = () => {
  const appAccToken = RootStore?.session?.appAccessToken
  const appRefToken = RootStore?.session?.appRefreshToken
  const request = extendAppSession(appAccToken, appRefToken)
  return executeRequest(request).then((response) => {
    return AppHeaderTransformer(response)
  })
}
